import { useContext, useState } from 'react'
import ModalComponent from '../../Modal'
import ButtonComponent from '../../Buttons/button-component'
import styles from './sociogram-table.module.scss'
import { useTranslation, Trans } from 'react-i18next'
import { useUpdateSociogramTeacherAccess } from '@BUP/hooks/Sociogram/teachersData/useUpdateTeacherAccess'
import { useQueryClient } from '@tanstack/react-query'
import { CurrentTermContext } from '@BUP/contexts/CurrentTermContext'
import { message } from 'antd'

const ShowTeacherResultsButton = ({ survey, loading }) => {
  const { teacherData, teacherEventAccess } = survey
  const { courses, user, enrollmentId } = teacherData
  const teacherName = user.name
  const courseName = courses?.[0]?.name
  const { hasAccess, eventId } = teacherEventAccess
  const i18n = useTranslation()
  const [stateModal, setStateModal] = useState(false)
  const term = useContext(CurrentTermContext)

  const queryClient = useQueryClient()

  const { isUpdatingAccess, updateTeacherAccess } = useUpdateSociogramTeacherAccess({
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['sociogramteachers', term.id],
        refetchType: 'all'
      })
      setStateModal(false)

      message.success(
        <Trans
          i18nKey={
          variables?.data?.hasAccess
            ? 'pages.data.sociogram.activeSociogramEce.resultsTeacherModal.messages.showSuccess'
            : 'pages.data.sociogram.activeSociogramEce.resultsTeacherModal.messages.hideSuccess'
        }
          values={{ teacherName }}
          components={{
            bold: <strong />
          }}
        />
      )
    },
    onError: (err) => {
      message.error(
        i18n.t('common.resources.generic.messages.error')
      )
      console.error(err)
    }
  })

  const handleShowModal = () => {
    setStateModal(true)
  }

  const handleCloseModal = () => {
    setStateModal(false)
  }

  const handleConfirmSurvey = () => {
    if (!eventId) {
      console.error('eventId not found for survey:', survey)
      return
    }
    updateTeacherAccess({
      enrollmentId,
      hasAccess: !hasAccess,
      eventId
    })
  }

  return (
    <div
      data-test='cell-wrapper-teacher-access-button'
      className={styles.actions_cell_wrapper}
    >
      <div className={styles.show_modal_button_wrapper}>
        <ButtonComponent
          buttonText={hasAccess ? `${i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.actions.hide')}` : `${i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.actions.show')}`}
          colorType='tertiary'
          block
          bold={false}
          onClick={() => handleShowModal(survey)}
          disabled={!teacherData || isUpdatingAccess}
          loading={isUpdatingAccess}
        />
      </div>
      <ModalComponent
        stateModal={stateModal}
        onClickCloseModal={() => {
          handleCloseModal()
        }}
        modalTitle={<>{hasAccess ? `${i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.title.hide')} ${courseName}` : `${i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.title.show')} ${courseName}`}</>}
        modalDescription={
          <div className={styles.modal_description_wrapper}>
            <Trans
              i18nKey={hasAccess ? `${i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.description.hide')}` : `${i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.description.show')}`}
              values={{ teacherName }}
              components={{ bold: <strong className={styles.teacher_name} /> }}
            />
          </div>
    }
        confirmButtonText={!hasAccess ? i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.actions.confirmShow') : i18n.t('pages.data.sociogram.activeSociogramEce.resultsTeacherModal.actions.confirmHide')}
        onClickConfirm={() => handleConfirmSurvey()}
        loading={isUpdatingAccess || loading}
        dataTest='update-teacher-access'
      />
    </div>
  )
}

export default ShowTeacherResultsButton
